import { render, staticRenderFns } from "./PptHelp.vue?vue&type=template&id=22c2baba&"
import script from "./PptHelp.vue?vue&type=script&lang=js&"
export * from "./PptHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/PptHelp.vue"
export default component.exports